import { FaultType } from "./constant/fault";
import { GroupValueKey } from "./constant/groupValueKey";
import { DiagnosticProviders } from "./constant/providers.enum";
import { Fault } from "./fault";

export class DiagnosticProvider {
    name: string;
    supportedProtocols: Array<string>;
    groupKey: string;
}

export const diagnosticProviders: DiagnosticProvider[] = [
    {
        name: DiagnosticProviders.Mitchell,
        supportedProtocols: [FaultType.j1708, FaultType.j1939, FaultType.odbii],
        groupKey: GroupValueKey.IsMitchell1
    },
    {
        name: DiagnosticProviders.Jaltest,
        supportedProtocols: [FaultType.j1708, FaultType.j1939, FaultType.odbii],
        groupKey: GroupValueKey.IsJaltest
    }
];
